module.exports = __webpack_public_path__ + "img/content_right3.e699082f.png";